import { Renderer } from "kernelplay-js";
import { Mouse } from "kernelplay-js";
import * as PIXI from "pixi.js";

export class PixiRenderer extends Renderer {
  async init(game) {
    super.init(game);

    this.type = "pixi";
    this.camera = game.camera;

    this.app = new PIXI.Application();

    // 🔥 IMPORTANT: init first
    await this.app.init({
      width: game.config.width,
      height: game.config.height,
      background: game.config.backgroundColor,
      antialias: true,
      resolution: window.devicePixelRatio || 1,
      autoDensity: true
    });

    game.canvas.canvas.replaceWith(this.app.canvas);
    game.canvas.canvas = this.app.canvas;
    this.stage = this.app.stage;

    // Create a persistent graphics object for debug drawing
    this.debugGraphics = new PIXI.Graphics();
    this.debugGraphics.zIndex = 9999; // Ensure it's on top
    this.debugPhysics = game.config.debugPhysics;
    this.stage.addChild(this.debugGraphics);

    Mouse.init(game.canvas.canvas); // 🔥 IMPORTANT
  }

  // render(scene) {
  //   for (const entity of scene.entities) {
  //     const t = entity.getComponent("transform");
  //     const renderer = entity.getComponent("renderer");


  //     if (!t || !renderer) continue;

  //     renderer.object.position.set(
  //       t.position.x,
  //       t.position.y
  //     );

  //     renderer.object.rotation = t.rotation.z;

  //     renderer.object.scale.set(
  //       t.scale.x,
  //       t.scale.y
  //     );
  //   }
  // }

  // WebGL2DRenderer.js

  // render(scene) {
  //   // console.log("hi");

  //   const camera = this.camera;
  //   const cameraBounds = camera.viewBounds;

  //   // 🔥 Get only visible renderers from spatial grid
  //   const visibleRenderers = scene._getVisibleRenderers(cameraBounds);

  //   // 🔥 Camera offset
  //   // this.stage.position.set(-camera.x, -camera.y);

  //   // 🔥 Only update visible objects
  //   for (const renderer of visibleRenderers) {
  //     if (!renderer.object) continue; // Skip non-PixiJS renderers

  //     const t = renderer.entity.getComponent("transform");

  //     renderer.object.position.set(t.position.x, t.position.y);
  //     renderer.object.rotation = t.rotation.z;
  //     renderer.object.scale.set(t.scale.x, t.scale.y);
  //   }
  // }

  // render(scene) {
  //   if (!this.app || !this.stage) return;  // ← not ready yet
  //   const camera = scene.getPrimaryCamera();
  //   if (!camera) return;

  //   const cameraBounds = camera.viewBounds;

  //   // ← use camera.position directly, viewBounds.x/y already has the offset baked in
  //   this.stage.position.set(
  //     -cameraBounds.x * camera.zoom,
  //     -cameraBounds.y * camera.zoom
  //   );
  //   this.stage.scale.set(camera.zoom, camera.zoom);

  //   // ← expand bounds for culling so objects don't pop at edges
  //   const PADDING = 10;
  //   const cullBounds = {
  //     x: cameraBounds.x - PADDING,
  //     y: cameraBounds.y - PADDING,
  //     width: cameraBounds.width + PADDING * 2,
  //     height: cameraBounds.height + PADDING * 2,
  //   };

  //   // ← get ALL renderers not just visible ones
  //   const allRenderers = scene._renderers;
  //   const visibleRenderers = scene._getVisibleRenderers(cullBounds);
  //   const visibleSet = new Set(visibleRenderers);

  //   for (const renderer of allRenderers) {
  //       if (!renderer.object) continue;

  //       if (!visibleSet.has(renderer)) {
  //           // ← hide culled objects instead of leaving them stale
  //           renderer.object.visible = false;
  //           continue;
  //       }

  //       renderer.object.visible = true;

  //       const t = renderer.entity?.getComponent("transform");
  //       if (!t) continue;

  //       const flipX = renderer.flipX ?? false;
  //       const flipY = renderer.flipY ?? false;

  //       renderer.object.position.set(t.position.x, t.position.y);
  //       renderer.object.rotation = t.rotation.z;
  //       renderer.object.scale.set(
  //           t.scale.x * (flipX ? -1 : 1),
  //           t.scale.y * (flipY ? -1 : 1)
  //       );
  //   }

  //   // 🔥 DEBUG DRAWING
  //   if (this.debugPhysics) {
  //     // console.log("hi");

  //     this.drawColliders(scene);
  //   } else {
  //     this.debugGraphics.clear();
  //   }
  // }

  render(scene) {
    if (!this.app || !this.stage) return;

    const camera = scene.getPrimaryCamera();
    if (!camera) return;

    const cameraBounds = camera.viewBounds;

    this.stage.position.set(
      -cameraBounds.x * camera.zoom,
      -cameraBounds.y * camera.zoom
    );
    this.stage.scale.set(camera.zoom, camera.zoom);

    const PADDING = 10;
    const cullBounds = {
      x: cameraBounds.x - PADDING,
      y: cameraBounds.y - PADDING,
      width: cameraBounds.width + PADDING * 2,
      height: cameraBounds.height + PADDING * 2,
    };

    const allRenderers = scene._renderers;
    const visibleRenderers = scene._getVisibleRenderers(cullBounds);
    const visibleSet = new Set(visibleRenderers);

    for (const renderer of allRenderers) {
      if (!renderer.object) continue;

      if (!visibleSet.has(renderer)) {
        renderer.object.visible = false;
        continue;
      }

      renderer.object.visible = true;

      const t = renderer.entity?.getComponent("transform");
      if (!t) continue;

      const flipX = renderer.flipX ?? false;
      const flipY = renderer.flipY ?? false;

      // 🔥 POSITION / ROTATION
      renderer.object.position.set(t.position.x, t.position.y);
      renderer.object.rotation = t.rotation.z;

      // 🔥 SCALE
      renderer.object.scale.set(
        t.scale.x * (flipX ? -1 : 1),
        t.scale.y * (flipY ? -1 : 1)
      );

      // 🔥 Z-INDEX (NEW)
      const z = renderer.entity?.zIndex ?? renderer.zIndex ?? 0;
      renderer.object.zIndex = z;
    }

    // 🔥 DEBUG
    if (this.debugPhysics) {
      this.drawColliders(scene);
    } else {
      this.debugGraphics.clear();
    }
  }

  drawColliders(scene) {
    const g = this.debugGraphics;
    g.clear();

    // Important: Pixi v8 sometimes needs a batch check
    // We loop through the scene's colliders
    for (const collider of scene._colliders) {
      const bounds = collider.bounds;
      if (!bounds) continue;

      const color = collider.isTrigger ? 0xFFFF00 : 0x00FF00;

      // 1. Start the drawing path
      g.rect(bounds.x, bounds.y, bounds.width, bounds.height);

      // 2. Apply the stroke to the path just created
      g.stroke({
        width: 2,
        color: color,
        alpha: 1,
        alignment: 0 // 0 is inner, 0.5 is middle, 1 is outer
      });
    }
  }

  destroy() {
    this.app.destroy(true);
  }
}
